import axios from 'axios'
import {
    Message,
    Loading
} from 'element-ui'
import store from '@/store'
import {
    getToken
} from '@/util/auth'

// 创建axios实例
const service = axios.create({
    baseURL: '/v1/sys', // api的base_url
    timeout: 10000 // 请求超时时间
})

let loading = null;

// request拦截器
service.interceptors.request.use(config => {
    if (config.showLoading == true) {
        loading = Loading.service({
            fullscreen: true,
            text: "加载中"
        });
    }
    if (store.getters.token) {
        config.headers['JUSHI-TOKEN'] = getToken() // 让每个请求携带token,
        config.headers['Accept'] = 'application/json'
    }
    console.log(config)

    return config
}, error => {
    // Do something with request error
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
    response => {
        if (loading !== null) {
            loading.close();
        }
        const res = response.data;
        if (res.code && res.code !== 200) {
            Message({
                message: res.msg,
                type: 'error',
                duration: 5 * 1000
            })
            return Promise.reject(res)
        } else {
            return Promise.resolve(res);
        }
    },
    error => {
        Message({
            message: error.msg,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/util/fetch.js